var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
var BaseTableFilters = /** @class */ (function (_super) {
    __extends(BaseTableFilters, _super);
    function BaseTableFilters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        return _this;
    }
    /**
     * Event emitted when the accept button is clicked
     */
    BaseTableFilters.prototype.onAcceptButtonClicked = function () {
        this.store.setLoading(true);
    };
    /**
     * Event emitted when the cancel button is clicked
     */
    BaseTableFilters.prototype.onCancelButtonClicked = function () {
        this.store.managementPage.closeFilterSidesheet();
    };
    BaseTableFilters.prototype.onVisibleChanged = function (val, oldVal) {
        if (val !== oldVal && val) {
            // emit a visibility changed event
            this.$emit('visible');
        }
    };
    Object.defineProperty(BaseTableFilters.prototype, "loading", {
        get: function () {
            return this.store.loading;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Boolean, required: true }),
        __metadata("design:type", Boolean)
    ], BaseTableFilters.prototype, "value", void 0);
    __decorate([
        Prop({ type: String, required: false, default: '350' }),
        __metadata("design:type", String)
    ], BaseTableFilters.prototype, "width", void 0);
    __decorate([
        Emit('accepted'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BaseTableFilters.prototype, "onAcceptButtonClicked", null);
    __decorate([
        Emit('cancelled'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BaseTableFilters.prototype, "onCancelButtonClicked", null);
    __decorate([
        Watch('value', { immediate: true, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], BaseTableFilters.prototype, "onVisibleChanged", null);
    BaseTableFilters = __decorate([
        Component
    ], BaseTableFilters);
    return BaseTableFilters;
}(Vue));
export default BaseTableFilters;
